import React from "react";
import { useTranslate } from 'react-redux-multilingual';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Style import
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClone } from '@fortawesome/free-solid-svg-icons';

const  DuplicateModalActionButton = (props) => {
    const t = useTranslate();

    const handleClick = () => {
        props.setModalDuplicateId(props.hisId)
        if(props.setModalDuplicateName) props.setModalDuplicateName(props.hisName)
    }

    return (
        <OverlayTrigger
            placement="bottom"
            overlay={
                <Tooltip id={`tooltip-${props.index}`}>
                    {t('duplicate')}
                </Tooltip>
            }
        >
            <span className="text-primary" onClick={() => handleClick()} style={{cursor:'Pointer'}}><FontAwesomeIcon icon={faClone} /></span>
        </OverlayTrigger>
    )
}

export default DuplicateModalActionButton;
